var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1F4F1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31373D",
    d: "M11 36s-4 0-4-4V4s0-4 4-4h14s4 0 4 4v28s0 4-4 4H11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#55ACEE",
    d: "M9 5h18v26H9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F4F1);
export default __webpack_public_path__ + "static/media/1f4f1.81cbcbdf83a210eac6194a49b6517a3b.svg";
export { ForwardRef as ReactComponent };